<div class="flex flex-col gap-1" data-test-class="filter-group">
	<span [id]="labelId()" class="font-semibold">
		{{ 'compositions.filters.type.' + title() + '.label' | translate }}
	</span>
	<vp-selection-card
		[ariaLabelledBy]="labelId()"
		[hideNativeInput]="true"
		[options]="options()"
		[stacked]="true"
		(optionsChange)="onOptionsChange($event)"
		controlType="checkbox"
	/>
</div>
